import LpOpsOutput from './output';
import LpOpsDocument from './document';
import LpOpsOVC from './ovc';
import LpOpsCheckout from './checkout';
import LpOpsInitializations from './initialization';
import LpUtils from './utils';
import LpTwoSteps from './two_steps';
import LpSlackOps from './slack_notifications';
import LpMandatory from './mandatory';
import LpContactsOps from './contacts';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/ops.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpOperations {
  constructor() {
    this.content = new LpOpsOutput();
    this.document = new LpOpsDocument();
    this.ovc = new LpOpsOVC();
    this.checkout = new LpOpsCheckout();
    this.initialization = new LpOpsInitializations();
    this.utils = new LpUtils();
    this.two_steps = new LpTwoSteps();
    this.slack = new LpSlackOps();
    this.mandatory = new LpMandatory();
    this.contacts = new LpContactsOps();
  }
}

export default LpOperations;



// WEBPACK FOOTER //
// ./src/app/ops/ops.js